export function isRoleAllowed(role, allowedRoles = []) {
  const safeRole = String(role || "").trim().toLowerCase();
  return Array.isArray(allowedRoles) && allowedRoles.includes(safeRole);
}
